import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPalmTree = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 512 512",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M407.749,128.831c-34.848-10.514-70.505-7.4-101.429,6.135c9.867-6.775,20.282-13.656,31.294-20.573 l-14.275-21.59l25.478,14.672c4.294-2.616,8.637-5.239,13.052-7.841c4.948-2.914,9.839-5.73,14.708-8.488L364.37,76.538 l21.547,9.362c9.398-5.196,18.639-10.108,27.596-14.672l-17.366-20.786l31.563,13.72c21.654-10.507,41.416-18.852,57.98-24.547 C439.39,3.268,373.733-3.13,319.969,28.561c-31.065,18.312-52.862,46.286-63.966,77.828 c-11.118-31.542-32.907-59.515-63.979-77.828C138.267-3.13,72.61,3.268,26.302,39.615c16.571,5.695,36.333,14.04,57.98,24.547 l31.563-13.72L98.479,71.228c8.964,4.564,18.206,9.476,27.604,14.672l21.54-9.362l-12.206,14.608 c4.877,2.758,9.76,5.574,14.708,8.488c4.422,2.602,8.758,5.225,13.058,7.841l25.472-14.672l-14.268,21.59 c11.012,6.917,21.426,13.798,31.286,20.573c-30.917-13.528-66.574-16.649-101.423-6.135C44.501,146.859,4.684,199.457,0,258.127 c15.419-8.31,34.954-17.175,57.361-25.962l11.317-32.501l3.498,26.864c9.433-3.498,19.307-6.952,29.501-10.343l7.728-22.18 l2.459,18.867c5.332-1.706,10.721-3.391,16.209-5.048c4.919-1.486,9.782-2.893,14.623-4.272l6.49-28.677l6.192,25.129 c38.459-10.428,73.406-17.359,100.625-20.388c27.213,3.029,62.16,9.96,100.612,20.388l6.192-25.129l6.498,28.677 c4.841,1.379,9.704,2.786,14.616,4.272c5.488,1.657,10.884,3.342,16.208,5.048l2.459-18.867l7.728,22.18 c10.194,3.391,20.068,6.846,29.509,10.343l3.49-26.864l11.324,32.501c22.4,8.786,41.943,17.651,57.361,25.962 C507.316,199.457,467.498,146.859,407.749,128.831z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "217.189,330.815 294.811,330.815 293.084,272.338 218.917,272.338  "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M256.003,197.275c-10.627,1.244-22.45,3.114-35.025,5.502l-1.5,50.551h73.044l-1.493-50.551 C278.446,200.389,266.624,198.519,256.003,197.275z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "214.9,408.301 297.107,408.301 295.372,349.824 216.627,349.824  "
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "st0",
			points: "214.331,427.31 212.071,503.844 299.929,503.844 297.669,427.31  "
		})
	] })]
});
export default SvgPalmTree;
